<template>
  <div v-if="!isLoadingPage">
    <div v-if="permission !== null">
      <div v-if="permission.read_perm == 1">
        <div class="fluid" id="payreqBillList">
          <div>
            <div class="payreq-bill-list-dev">
              <v-card elevation="0" class="px-3 py-2" style="width: 100%">
                <v-row>
                  <v-col
                    cols="12"
                    class="d-flex"
                    style="
                      position: relative;
                      padding: 0 20px;
                      text-align: center;
                      margin-top: 20px;
                    "
                  >
                    <h4
                      class="indigo--text"
                      style="font-weight: bold; margin: auto"
                    >
                      PAYMENT REQUEST - BILLING
                      <v-tooltip bottom color="grey">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            x-small
                            text
                            icon
                            color="grey darken-2"
                            @click="getDataFromApi"
                          >
                            <v-icon small>mdi-refresh</v-icon>
                          </v-btn>
                        </template>
                        <span>refresh page</span>
                      </v-tooltip>
                    </h4>
                  </v-col>
                  <v-col cols="12">
                    <div>
                      <v-toolbar
                        class="payreq-bill-list-toolbar-1"
                        flat
                        style="
                          height: 60px;
                          border-radius: 10px 10px 0 0;
                          margin-top: 15px;
                        "
                      >
                        <div
                          class="d-flex align-content-start justify-between"
                          style="width: 100%"
                        >
                          <v-btn
                            outlined
                            small
                            elevation="1"
                            color="indigo"
                            class="indigo--text"
                            style="font-size: 12px; margin-right: 15px"
                            @click="exportData"
                          >
                            Export Data
                          </v-btn>
                          <div class="d-flex" style="margin-left: auto">
                            <div style="width: 390px; height: 45px">
                              <v-text-field
                                v-model="paramAPI.keyword"
                                label="cari dokumen"
                                type="search"
                                outlined
                                dense
                                append-icon="mdi-magnify"
                                style="margin-left: 15px; font-size: 12px"
                                @keyup.enter="searchEnter"
                                :disabled="loading"
                              ></v-text-field>
                            </div>
                          </div>
                        </div>
                      </v-toolbar>
                      <v-toolbar
                        class="payreq-bill-list-toolbar-1"
                        flat
                        style="
                          height: 60px;
                          border-radius: 10px 10px 0 0;
                          margin-top: 10px;
                        "
                      >
                        <div
                          class="d-flex align-content-center justify-space-between"
                          style="width: 100%"
                        >
                          <div style="width: 210px">
                            <v-autocomplete
                              v-model="paramAPI.company_id"
                              label="Company"
                              item-text="name"
                              item-value="id"
                              style="font-size: 12px"
                              return-object
                              dense
                              outlined
                              clearable
                              @change="companyWatcher"
                              :items="dropdown.company"
                              :disabled="isDisableCompanyDropdown"
                            ></v-autocomplete>
                          </div>
                          <div style="width: 210px; margin-left: 15px">
                            <v-autocomplete
                              v-model="paramAPI.department_id"
                              label="Department"
                              item-text="name"
                              item-value="id"
                              style="font-size: 12px"
                              return-object
                              dense
                              outlined
                              clearable
                              @change="departmentWatcher"
                              :items="dropdown.department"
                            ></v-autocomplete>
                          </div>
                          <div style="width: 210px; margin-left: 15px">
                            <v-autocomplete
                              v-model="paramAPI.vendor_id"
                              label="Vendor"
                              item-text="name"
                              item-value="id"
                              style="font-size: 12px; height: 55px"
                              return-id
                              dense
                              outlined
                              clearable
                              @change="vendorWatcher"
                              :items="dropdown.vendor"
                              :search-input.sync="vendorSearch"
                              :filter="vendorCustomFilter"
                              @keydown.enter.prevent="
                                getDropdownVendor(vendorSearch)
                              "
                            >
                              <template v-slot:item="data">
                                <template>
                                  <v-list-item-content>
                                    <v-list-item-title class="d-flex">
                                      <span
                                        style="
                                          font-size: 12px;
                                          margin-right: 5px;
                                        "
                                      >
                                        ({{ data.item.code }})
                                      </span>
                                      {{ data.item.name }}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </template></v-autocomplete
                            >
                          </div>

                          <div style="width: 210px; margin-left: 15px">
                            <v-select
                              label="Status"
                              v-model="paramAPI.status_id"
                              :items="dropdown.status"
                              style="font-size: 12px"
                              item-text="name"
                              item-value="id"
                              return-id
                              dense
                              clearable
                              outlined
                              @change="statusWatcher"
                            ></v-select>
                          </div>
                          <div style="width: 180px; margin-left: auto">
                            <v-text-field
                              dense
                              v-model="paramAPI.start_date"
                              label="Dari Tanggal"
                              type="date"
                              name="startdate"
                              style="height: 30px"
                              step="1"
                              outlined
                              clearable
                              @change="startDateWatcher"
                            />
                          </div>
                          <div style="width: 180px; margin-left: 15px">
                            <v-text-field
                              dense
                              v-model="paramAPI.end_date"
                              label="Sampai Tanggal"
                              type="date"
                              name="startdate"
                              style="height: 30px"
                              step="1"
                              outlined
                              clearable
                              @change="endDateWatcher"
                            />
                          </div>
                        </div>
                      </v-toolbar>
                    </div>
                  </v-col>

                  <v-col cols="12" style="width: 100%">
                    <v-data-table
                      v-if="result.length > 0 || !skeleton_loading"
                      mobile-breakpoint="0"
                      fixed-header
                      height="50vh"
                      :headers="headers"
                      style="cursor: pointer"
                      :items="result"
                      :loading="loading"
                      @click:row="rowClick"
                      item-key="id"
                      :options.sync="options"
                      :footer-props="{
                        showFirstLastPage: true,
                        showCurrentPage: true,
                        itemsPerPageOptions: [1, 3, 5, 10, 15, 100, 500]
                      }"
                      :server-items-length="totalData"
                      :page="paramAPI.page"
                      @update:page="updatePage"
                      :items-per-page="paramAPI.itemsPerPage"
                      @update:items-per-page="updateItemPerPage"
                    >
                      <template v-slot:[`item.document_no`]="{ item }">
                        <div
                          :style="`min-width:100px; font-size:10px; padding: 0; display: flex; flex-direction: row; justify-content: start; align-items:center;`"
                        >
                          {{ item.document_no }}
                        </div>
                      </template>
                      <template v-slot:[`item.purchase_request`]="{ item }">
                        <div
                          :style="`min-width:100px; font-size:10px; padding: 0; display: flex; flex-direction: row; justify-content: start; align-items:center;`"
                        >
                          {{
                            item.purchase_request != null
                              ? item.purchase_request.request_no
                              : ''
                          }}
                        </div>
                      </template>
                      <template v-slot:[`item.pjca`]="{ item }">
                        <div
                          v-if="item.pjca && item.pjca.length > 0"
                          :style="`min-width:100px; font-size:10px; padding: 0; display: flex; flex-direction: column; justify-content: start; align-items:center;`"
                        >
                          <!-- <v-icon x-small color="green"
                            >mdi-check-circle-outline</v-icon
                          > -->
                          <div
                            v-for="(item, index) in item.pjca"
                            :key="index"
                            class="d-flex justify-center align-center flex-column"
                          >
                            <span v-if="item.status < 3">
                              {{ item.document_no }}
                            </span>
                          </div>
                        </div>
                      </template>
                      <template v-slot:[`item.company_name`]="{ item }">
                        <div
                          :style="`width:100px; font-size:10px; padding: 0; display: flex; flex-direction: row; justify-content: start; align-items:center;`"
                        >
                          {{ item.company_name }}
                        </div>
                      </template>
                      <template v-slot:[`item.department_name`]="{ item }">
                        <div
                          :style="`width:100px; font-size:10px; padding: 0; display: flex; flex-direction: row; justify-content: start; align-items:center;`"
                        >
                          {{ item.department_name }}
                        </div>
                      </template>
                      <template v-slot:[`item.vendor_name`]="{ item }">
                        <div
                          :style="`width:100px; font-size:10px; padding: 0; display: flex; flex-direction: row; justify-content: start; align-items:center;`"
                        >
                          {{ item.vendor_name }}
                        </div>
                      </template>
                      <template v-slot:[`item.created_at`]="{ item }">
                        <div
                          style="
                            width: 120px;
                            font-size: 11px;
                            padding: 0;
                            display: flex;
                            flex-direction: row;
                          "
                        >
                          {{ convertDate(item.created_at) }}
                        </div>
                      </template>
                      <!-- <template v-slot:[`item.updated_at`]="{ item }">
                        <div
                          style="
                            font-size: 12px;
                            padding: 0;
                            display: flex;
                            flex-direction: row;
                          "
                        >
                          {{ convertDate(item.updated_at) }}
                        </div>
                      </template> -->
                      <template v-slot:[`item.status`]="{ item }">
                        <div
                          :style="`text-transform:uppercase; width: 90px; font-size:8px; font-weight:bolder; padding: 0; display: flex; flex-direction: row; color:${statusColor(
                            item.status
                          )};`"
                        >
                          {{ statusName(item.status) }}
                        </div>
                      </template>
                      <template v-slot:[`item.payment_type`]="{ item }">
                        <div
                          style="
                            width: 90px;
                            text-transform: uppercase;
                            font-size: 11px;
                            font-weight: bolder;
                            padding: 0;
                            display: flex;
                            flex-direction: row;
                          "
                        >
                          {{ paymentTypeName(item.payment_type) }}
                        </div>
                      </template>
                      <template v-slot:[`item.payreq_type`]="{ item }">
                        <div
                          style="
                            text-transform: uppercase;
                            font-size: 11px;
                            font-weight: bolder;
                            padding: 0;
                            display: flex;
                            flex-direction: row;
                          "
                        >
                          {{
                            item.app_category != 2
                              ? payreqTypeName(item.payreq_type)
                              : 'BILL'
                          }}
                        </div>
                      </template>
                      <template v-slot:[`item.employee_name`]="{ item }">
                        <div
                          style="
                            width: 100px;
                            font-size: 11px;
                            padding: 0;
                            display: flex;
                            flex-direction: row;
                          "
                        >
                          {{ item.employee_name }}
                        </div>
                      </template>

                      <template v-slot:[`item.invoice_due_date`]="{ item }">
                        <div style="width: 70px; font-size: 11px">
                          {{ item.invoice_due_date }}
                        </div>
                      </template>
                      <template v-slot:[`item.receive_invoice_date`]="{ item }">
                        <div style="width: 70px; font-size: 11px">
                          {{ item.receive_invoice_date }}
                        </div>
                      </template>
                      <template v-slot:[`item.invoice_date`]="{ item }">
                        <div style="width: 70px; font-size: 11px">
                          {{ item.invoice_date }}
                        </div>
                      </template>
                      <template v-slot:[`item.invoice_no`]="{ item }">
                        <div style="width: 100px; font-size: 11px">
                          {{ item.invoice_no }}
                        </div>
                      </template>
                      <template v-slot:[`item.odoo_bill_no`]="{ item }">
                        <div style="width: 100px; font-size: 11px">
                          {{ item.odoo_bill_no }}
                        </div>
                      </template>
                      <template v-slot:[`item.total_after_tax`]="{ item }">
                        <div style="width: 80px; font-size: 11px">
                          {{ priceConvert(item.total_after_tax) }}
                        </div>
                      </template>
                      <template v-slot:[`item.deduction`]="{ item }">
                        <div style="width: 80px; font-size: 11px">
                          {{ priceConvert(item.deduction) }}
                        </div>
                      </template>
                      <template v-slot:[`item.debt_value`]="{ item }">
                        <div style="width: 80px; font-size: 11px">
                          {{ priceConvert(item.debt_value) }}
                        </div>
                      </template>
                    </v-data-table>
                    <v-skeleton-loader
                      v-else
                      style="width: 100%"
                      type="table-heading, table-tbody, table-tfoot"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-card
      v-else
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      YOU CANNOT ACCESS THIS PAGE
    </v-card>
  </div>
  <div v-else>
    <v-card
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      <v-progress-circular :size="170" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import buildType from '../../../services/buildType.js'
import { globalMixin } from '../../../mixin/globalMixin'
import * as XLSX from 'xlsx/xlsx.mjs'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'msovertime',
  components: {},
  mixins: [globalMixin],
  data: () => ({
    editDialog: false,
    settingDialog: false,
    config: require('../../../services/config.json')[env],
    proc: buildType.apiURL('proc'),
    hrsApi: buildType.apiURL('hrs'),
    eSanqua: buildType.apiURL('esanqua'),
    build: process.env.VUE_APP_BUILD_TYPE,
    permission: null,
    appLevel: null,
    userLevel: null,
    isLoadingPage: true,
    isDisableCompanyDropdown: false,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'id',
      sortType: 'asc',
      company_id: null,
      department_id: null,
      employee_id: null,
      mode: 1,
      status_id: null,
      documentType: 1,
      start_date: null,
      end_date: null,
      vendor_id: null,
      appCategory: 2
    },
    totalData: 0,
    isEdit: false,

    options: {},
    actionValue: 0,
    result: [],
    loading: false,
    dropdown: {
      company: [],
      department: [],
      status: [],
      vendor: [],
      unit: []
      // currency: []
    },
    skeleton_loading: true,
    vendorSearch: null,
    selectVendor: null
  }),

  async mounted() {
    if (
      this.getUserProfile.employee.company.plant_id == 5 ||
      this.getUserProfile.employee.company.plant_id == 6
    ) {
      this.appLevel = this.config.application.ecatalogue.userLevel
      this.appLevel.administrator =
        this.config.application.all.userLevel.administrator
      this.getDataMenu()
      // this.getDataFromApi()
    } else {
      this.isLoadingPage = false
    }
  },
  computed: {
    // , 'getDropdownPlant'
    ...mapGetters(['getUserProfile', 'getPaybillPageQuery']),
    headers() {
      const xArr = [
        {
          text: 'Payreq No.',
          value: 'document_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Invoice No.',
          value: 'invoice_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Bill No.',
          value: 'odoo_bill_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Nilai Faktur',
          value: 'total_after_tax',
          align: 'left',
          sortable: false
        },
        {
          text: 'Potongan',
          value: 'deduction',
          align: 'left',
          sortable: false
        },
        {
          text: 'Hutang',
          value: 'debt_value',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Invoice',
          value: 'invoice_date',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Terima Faktur',
          value: 'receive_invoice_date',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Jatuh Tempo',
          value: 'invoice_due_date',
          align: 'left',
          sortable: false
        },
        {
          text: 'Vendor',
          value: 'vendor_name',
          sortable: false
        },
        {
          text: 'Perusahaan',
          value: 'company_name',
          sortable: false
        },
        {
          text: 'PIC',
          value: 'employee_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Jenis Payreq',
          value: 'payreq_type',
          sortable: false
        },
        {
          text: 'Jenis Pembayaran',
          value: 'payment_type',
          sortable: false
        },
        {
          text: 'Department',
          value: 'department_name',
          sortable: false
        },
        {
          text: 'Dibuat pada',
          value: 'created_at',
          align: 'left',
          sortable: true
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false
        }
      ]
      return xArr
    }
  },
  watch: {
    options: {
      handler(newVal, oldVal) {
        console.log('options handle', newVal, oldVal)
        if (
          newVal.page !== oldVal.page || newVal.itemsPerPage !== oldVal.itemsPerPage
        ) {
          return
        }

        if (
          this.options.sortBy.length === 1 &&
          this.options.sortDesc.length === 1
        ) {
          this.paramAPI.sortType = this.options.sortDesc[0] ? 'desc' : 'asc'
          this.paramAPI.sortBy =
            this.options.sortBy[0] == 'document_no'
              ? 'id'
              : this.options.sortBy[0]
          // this.paramAPI.sortBy = 'id'
        } else {
          this.paramAPI.sortType = 'asc'
          this.paramAPI.sortBy = 'id'
        }
        this.resetSomeParam()
        this.getDataFromApi()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['menu_access', 'getMenuId']),
    ...mapMutations(['setPaybillPageQuery', 'setPaybillQueue']),
    importData() {},
    async exportData() {
      this.showMsgDialog3(
        '',
        'Anda yakin ingin melakukan export data ?',
        true,
        'Export Sekarang',
        'Batal'
      ).then(async (res) => {
        let url = null
        if (res.isConfirmed) {
          url = `${this.proc}payreq/bill/list?keyword=${
            this.paramAPI.keyword
          }&offset=${this.paramAPI.offset * this.paramAPI.limit}&limit=${
            this.paramAPI.limit
          }&order_by=${this.paramAPI.sortBy}&order_type=${
            this.paramAPI.sortType
          }`

          if (this.paramAPI.status_id !== null) {
            url = url + `&status=${this.paramAPI.status_id}`
            // Object.assign(querySetting, { st: `${this.paramAPI.status_id}` })
          }
          // if (this.paramAPI.appCategory !== null) {
          //   url = url + `&app_category=${this.paramAPI.appCategory}`
          //   // Object.assign(querySetting, { cp: `${this.paramAPI.company_id.id}` })
          // }
          if (this.paramAPI.company_id !== null) {
            url = url + `&company_id=${this.paramAPI.company_id.id}`
            // Object.assign(querySetting, { cp: `${this.paramAPI.company_id.id}` })
          }
          if (this.paramAPI.department_id !== null) {
            url = url + `&department_id=${this.paramAPI.department_id.id}`
          }
          if (this.paramAPI.start_date !== null) {
            url = url + `&start_date=${this.paramAPI.start_date}`
          }
          if (this.paramAPI.end_date !== null) {
            url = url + `&end_date=${this.paramAPI.end_date}`
          }
          if (this.paramAPI.vendor_id !== null) {
            url = url + `&vendor_id=${this.paramAPI.vendor_id}`
          }
        }
        // const url = this.url + '&is_export=true'
        await axios
          .get(url)
          .then((res) => {
            // console.log(res)
            // let selectedData = []
            const response = res.data.data
            if (response !== undefined) {
              // for (let i = 0; i < response.length; i++) {
              //   selectedData.push({
              //     request_no: response[i].request_no,
              //     employee: response[i].employee.name,
              //     department: response[i].department.name,
              //     company: response[i].company.name,
              //     submit_date: response[i].requested_at,
              //     status: response[i].status.name,
              //     created_at: response[i].created_at,
              //     project: response[i].project,
              //     fpb_type_id: response[i].fpb_type_id,
              //     fpb_type_name: response[i].fpb_type_name,
              //     item: response[i].item !== undefined ? response[i].item : null
              //   })
              // }
              this.exportNow(response)
            } else {
              // selectedData = []
            }
            return null
          })
          .catch((error) => {
            console.log(error)
            return null
          })
      })
    },
    exportNow(selectedData) {
      const arrData = []
      for (let i = 0; i < selectedData.length; i++) {
        const param = {
          'Payreq No': selectedData[i].document_no,
          'Invoice No': selectedData[i].invoice_no,
          'Bill No': selectedData[i].odoo_bill_no,
          'Nilai Faktur': selectedData[i].total_after_tax,
          Potongan: selectedData[i].deduction,
          Hutang: selectedData[i].debt_value,
          'Tgl. Invoice': selectedData[i].invoice_date,
          'Tgl. Terima Faktur': selectedData[i].receive_invoice_date,
          'Tgl. Jatuh Tempo': selectedData[i].invoice_due_date,
          'Vendor Invoice': selectedData[i].vendor_name,
          'Vendor Payreq': selectedData[i].vendor_name,
          Perusahaan: selectedData[i].company_name,
          PIC: selectedData[i].employee_name,
          'Jenis Payreq':
            selectedData[i].app_category != 2
              ? this.payreqTypeName(selectedData[i].payreq_type)
              : 'BILL',
          'Jenis Pembayaran': this.paymentTypeName(
            selectedData[i].payment_type
          ),
          Department: selectedData[i].department_name,
          'Dibuat pada': selectedData[i].created_at,
          Status: this.statusName(selectedData[i].status)
        }

        arrData.push(param)
      }
      this.downloadExcell(arrData)
    },
    downloadExcell(arrData) {
      const data = XLSX.utils.json_to_sheet(arrData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data, 'data')
      const date = new Date()
      XLSX.writeFile(wb, `Paybill_${date.toLocaleDateString('id')}.xlsx`)
    },
    openFormPayreq(val) {
      if (val == 'open') {
        this.getDropdownUnit()
        // this.getDropdownCurrency()
        setTimeout(() => {
          document.getElementById('billingPayreqForm').click()
        }, 200)
      }
      if (val == 'close') {
        // this.actionValue = 0
        this.dropdown.unit = []
        // this.dropdown.currency = []
      }
    },
    getDropdownUnit() {
      axios
        .get(`${this.proc}master/unit/drop_down?keyword=`)
        .then((res) => {
          this.dropdown.unit = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDropdownCurrency() {
      axios
        .get(`${this.proc}master/currency/drop_down?keyword=`)
        .then((res) => {
          // console.log('currency>>>', res.data)
          this.dropdown.currency = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async getDataMenu() {
      this.isLoadingPage = true
      const split = this.$route.path.split('/')
      const routeModule = '/' + split[1] + '/' + split[2]
      console.log('Path>>>>>', routeModule)
      await this.getMenuId({
        keyword: this.paramAPI.keyword,
        path: routeModule
      })
        .then((result) => {
          if (result.data.status_code === '00') {
            const menuId = result.data.data[0].id
            this.userLevel = this.getUserProfile.level.find(
              ({ application }) =>
                application.id ===
                  this.config.application.ecatalogue.applicationId ||
                application.id === this.config.application.all.applicationId
            )
            console.log('userLevel>>>>>', this.userLevel)
            if (this.userLevel !== null) {
              if (
                this.getUserProfile.level.find(
                  ({ id }) => id == this.appLevel.administrator
                ) !== undefined
              ) {
                this.resetPermission({
                  data: {
                    read_perm: 1,
                    create_perm: 1,
                    update_perm: 1,
                    delete_perm: 1
                  }
                })
              } else {
                this.checkMenuAccess([menuId, this.userLevel.id])
              }
            } else {
              this.resetPermission(null)
            }
          } else {
            this.isLoadingPage = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.isLoadingPage = false
        })
    },
    async checkMenuAccess(payload) {
      await this.menu_access(payload)
        .then((result) => {
          console.log('menuAccess>>>>', result)
          this.resetPermission(result)
        })
        .catch((err) => {
          console.log(err)
          this.resetPermission(null)
        })
    },
    resetPermission(val) {
      this.permission = null

      if (val !== null) {
        if (val.data !== null) {
          if (val.data.read_perm === 1) {
            this.permission = val.data
            this.initDataForLayout()
          }
        }
      }
      this.isLoadingPage = false
    },
    async initDataForLayout() {
      if (this.userLevel.is_support) {
        this.paramAPI.company_id = {
          id: 0,
          name: ''
        }
      } else {
        this.paramAPI.company_id = {
          id: Number(this.getUserProfile.employee.company.plant_id),
          name: this.getUserProfile.employee.company.name
        }
      }

      if (
        this.getUserProfile.level.find(
          ({ id }) => id == this.appLevel.adminMaster
        ) !== undefined
      ) {
        this.paramAPI.mode = ''
      }
      if (this.getPaybillPageQuery !== null) {
        this.paramAPI = this.getPaybillPageQuery
      }
      setTimeout(async () => {
        this.initDropdown()
        await this.getDataFromApi()
      }, 200)
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    resetSomeParam() {
      // this.paramAPI.limit = this.paramAPI.itemsPerPage
      this.paramAPI.page = 1
      this.paramAPI.offset = 0
      this.paramAPI.limit = 10
      this.paramAPI.itemsPerPage = 10
    },
    searchEnter() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    async initDropdown() {
      this.getDropdownCompany()
      this.dropdownDepartment()
      this.dropdownStatus()
    },
    companyWatcher(v) {
      this.resetSomeParam()
      this.getDataFromApi()

      if (v != null) {
        this.dropdownDepartment()
      } else {
        this.dropdown.department = []
      }
    },
    departmentWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    async statusWatcher(v) {
      this.paramAPI.status_id = v
      this.resetSomeParam()
      setTimeout(async () => {
        await this.getDataFromApi()
      }, 100)
    },
    async startDateWatcher(v) {
      this.resetSomeParam()
      setTimeout(async () => {
        await this.getDataFromApi()
      }, 100)
    },
    async endDateWatcher(v) {
      this.resetSomeParam()
      setTimeout(async () => {
        await this.getDataFromApi()
      }, 100)
    },
    vendorWatcher(v) {
      console.log(v)
      if (v == null) {
        this.dropdown.vendor = []
      }
      this.resetSomeParam()
      setTimeout(async () => {
        await this.getDataFromApi()
      }, 100)
    },
    dropdownStatus() {
      this.dropdown.status = [
        {
          id: 0,
          name: 'Draft'
        },
        {
          id: 1,
          name: 'Waiting Approval'
        },
        {
          id: 2,
          name: 'In Progress'
        },
        {
          id: 3,
          name: 'Paid'
        },
        {
          id: 4,
          name: 'Cancel'
        },
        {
          id: 5,
          name: 'Reject'
        }
      ]
    },
    async getDropdownCompany() {
      if (this.userLevel !== null) {
        // if (this.userLevel.is_admin !== null) {
        if (this.userLevel.user_user_level !== null) {
          if (
            this.userLevel.user_user_level.allowed_company === null ||
            this.userLevel.user_user_level.allowed_company.length === 0
          ) {
            this.dropdownCompanyApi()
          } else {
            this.dropdown.company =
              this.userLevel.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          this.dropdownCompanyApi()
        }
        // }
      }
      // else {
      //   this.dropdownCompanyApi()
      // }
    },
    async dropdownCompanyApi() {
      if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
        this.isDisableCompanyDropdown = this.userLevel.is_support
      } else {
        this.isDisableCompanyDropdown = false
      }
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          this.dropdown.company = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async dropdownDepartment() {
      let url = `${this.hrsApi}master/universal/department/dropdown`
      if (this.paramAPI.company_id != null) {
        url = url + `?filter=[{"company_id":${this.paramAPI.company_id.id}}]`
      }
      await axios
        .get(url)
        .then((res) => {
          console.log('department>>>', res)
          if (res.data.status_code === '00') {
            return (this.dropdown.department = res.data.data)
          }
          return (this.dropdown.department = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.department = [])
        })
    },
    async getDataFromApi() {
      this.loading = true

      await this.initDataTable()
        .then((data) => {
          if (data.status_code === '00') {
            this.totalData = Number(data.total_record)
            return (this.result = data.data)
          }
          this.totalData = 0
          return (this.result = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.result = [])
        })
      this.skeleton_loading = false
      this.loading = false
    },
    async initDataTable() {
      console.log(this.paramAPI)

      let url = `${this.proc}payreq/bill/list?keyword=${
        this.paramAPI.keyword
      }&offset=${this.paramAPI.offset * this.paramAPI.limit}&limit=${
        this.paramAPI.limit
      }&order_by=${this.paramAPI.sortBy}&order_type=${this.paramAPI.sortType}`

      if (this.paramAPI.status_id !== null) {
        url = url + `&status=${this.paramAPI.status_id}`
        // Object.assign(querySetting, { st: `${this.paramAPI.status_id}` })
      }
      if (this.paramAPI.appCategory !== null) {
        url = url + `&app_category=${this.paramAPI.appCategory}`
        // Object.assign(querySetting, { cp: `${this.paramAPI.company_id.id}` })
      }
      if (this.paramAPI.company_id !== null) {
        url = url + `&company_id=${this.paramAPI.company_id.id}`
        // Object.assign(querySetting, { cp: `${this.paramAPI.company_id.id}` })
      }
      if (this.paramAPI.department_id !== null) {
        url = url + `&department_id=${this.paramAPI.department_id.id}`
      }
      if (this.paramAPI.start_date !== null) {
        url = url + `&start_date=${this.paramAPI.start_date}`
      }
      if (this.paramAPI.end_date !== null) {
        url = url + `&end_date=${this.paramAPI.end_date}`
      }
      if (this.paramAPI.vendor_id !== null) {
        url = url + `&vendor_id=${this.paramAPI.vendor_id}`
      }
      this.setPaybillPageQuery(this.paramAPI)

      return await new Promise((resolve) => {
        axios
          .get(url)
          .then((res) => {
            console.log('list payreq >>>>', res)
            resolve(res.data)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    getDropdownVendor(val) {
      val && val != this.selectVendor && this.querySelections(val)
    },
    async querySelections(v) {
      await axios
        .get(
          `${this.proc}vendor/dropdown?keyword=${v}&offset=0&limit=100&order_by=name&order_type=asc`
        )
        .then((res) => {
          this.loading = false
          if (res.data.status_code === '00') {
            return (this.dropdown.vendor = res.data.data)
          }
          return (this.dropdown.vendor = [])
        })
        .catch((err) => {
          this.dropdown.vendor = []
          return console.log(err)
        })
    },

    vendorCustomFilter(item, queryText, itemText) {
      return (
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        item.code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1
      )
    },
    rowClick(pValue, pSlot) {
      const arrItem = {
        list: this.result
        // index: pSlot.index
      }
      this.$store.commit('setPaybillQueue', arrItem)
      setTimeout(() => {
        this.$router.push(
          `/e-catalogue/payreq/detail/${pValue.payment_request_id}?idx=${pSlot.index}`
        )
      }, 200)
    },
    async updatePage(p) {
      console.log('update page>>>', p)
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      console.log('update updateItemPerPage>>>', p)
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    paymentTypeName(val) {
      const arrType = ['Tunai', 'Bank']
      return arrType[val - 1]
    },
    payreqTypeName(val) {
      const arrType = ['CA', 'Reimburs', 'Lain-lain']
      return arrType[val - 1]
    },
    statusName(val) {
      const arrType = [
        'DRAFT',
        'WAITING APPROVAL',
        'IN PROGRESS',
        'PAID',
        'CANCEL',
        'REJECT'
      ]
      return arrType[val]
    },
    statusColor(val) {
      const arrType = ['grey', 'orange', 'blue', 'green', 'red', 'red']
      return arrType[val]
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    }
  }
}
</script>
<style lang="scss">
#payreqBillList {
  position: relative;
  .payreq-bill-list-dev {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .payreq-bill-list-toolbar-1 {
      .payreq-bill-list-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .activity-list-toolbar-2 {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  #payreqBillList {
    .payreq-bill-list-dev {
      .payreq-bill-list-toolbar-1 {
        .payreq-bill-list-toolbar-1 {
          display: none;
        }
      }
      .activity-list-toolbar-2 {
        display: block;
      }
    }
  }
}
</style>
